import { useTranslation } from "react-i18next";
import { FilterOptions } from "../../types";

export const useStatusPopoverOptions = (): FilterOptions[] => {
    const { t } = useTranslation();

    return [
        {
            label: t('published'),
            value: 'published',
        },
        {
            label: t('unpublished'),
            value: 'notpublished',
        },
    ];
};